<template>
   <!-- 全屏遮罩 -->
    <div class = "fullscreen"   v-loading="loading"
        element-loading-text="读取中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :style="loading?'':'display:none'">
    </div>
</template>
<script>
import http from '@/api/http'
export default {
  name:"aycanImages",//阅片组件
  props:{
    hospitalId:{//医院id
      require:true,
      type: String,
    },
    studyPk:{//医院id
      require:true,
      type: String,
    },
    studyUid:{//uid
      require:true,
      type: String,
    },
    isBenYuan:{
      require:false,
      type:Boolean,
      default:false,
    }
  },
  data(){
    return{
      loading:false,
      startDate:'',//开始时间 用于判断是否超过60秒
      consultImagesStatusInterva:'',//用于存放轮询
    }
  },
  beforeDestroy() {
    //关闭页面前销毁循环 以防用户阅片 还未返回 账号被顶 陷入死循环
    window.clearInterval(this.consultImagesStatusInterva);
  },
  methods:{
    getConsultImages(){
      //打开全屏loading
      this.loading = true;
      //设置开始时间
      this.startDate =  (new Date()).getTime();

      let sendData = {
        hospitalId:this.hospitalId,
        studyPk:this.studyPk,
        studyUid:this.studyUid,
      }
      let url = ""
      if(this.isBenYuan){
        url='newPrepareAycanBenYuan.json'
      }else{
        url='newPrepareAycan.json'
      }
      http.post( url,sendData).then(res => {   //旧窗口请求阅片

        if (res.data.code === "SUCCESS") {

          //轮询consultImagesStatus
        this.consultImagesStatusInterva=setInterval(this.consultImagesStatus,2000);

        }else{
          this.$message.error(res.data.msg);
          this.loading=false;
        }
      }).catch((e) => {
        this.$message.error(e,'newPrepareAycan网络错误');
        this.loading=false
      })
    },
    consultImagesStatus(){
    //获取当前时间 与开始时间做对比 如果超过60秒则弹出提示是否继续等待
    const nowDate =  (new Date()).getTime();
    if(nowDate-this.startDate>60000){

      //先停下轮询
      window.clearInterval(this.consultImagesStatusInterva);

      this.$confirm('是否继续等待?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        //继续等待重置开始时间
        this.startDate=(new Date()).getTime();
        //继续开始 轮询consultImagesStatus
        this.consultImagesStatusInterva=setInterval(this.consultImagesStatus,2000);

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
        this.loading=false;
        return;
      });

    }else{
      let sendData = {
        hospitalId:this.hospitalId,
        studyPk:this.studyPk,
        studyUid:this.studyUid,
      }
      http.post('consultImagesStatus.json',sendData).then(res => {
        if(res.data.code === "SUCCESS"){

          //如果返回为SUCCESS 则清除定时器 并跳转到阅片页面
          this.loading = false;
          window.clearInterval(this.consultImagesStatusInterva);
          window.open(res.data.model,'_blank');
        }else if(res.data.code === "ERROR"){
          //如果返回为error 则清除定时器 并报出错误
          window.clearInterval(this.consultImagesStatusInterva);
          this.$message.error('阅片地址查询出错');
          this.loading = false;
        }
      }).catch(e=>{
        this.$message.error('consultImagesStatus网络错误');
        this.loading = false
      })
    }
    },
  }

}
</script>

<style scoped>
  .fullscreen{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
}
</style>



// WEBPACK FOOTER //
// aycanImages.vue?66b9eeec